// extracted by mini-css-extract-plugin
export default {"main":"Breadcrumbs_main__8S3pe","stepText":"Breadcrumbs_stepText__O8xxW","active":"Breadcrumbs_active__p52jV","arrowBetween":"Breadcrumbs_arrowBetween__0WyWE"};